var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEuropeanUnion = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5207_30118)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.49932 2.93555L7.74216 3.68288H8.5279L7.89219 4.14475L8.13503 4.89208L7.49932 4.43019L6.86357 4.89208L7.10642 4.14475L6.4707 3.68288H7.25647L7.49932 2.93555Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.27208 4.27309L4.97228 4.6298L5.52789 4.07422L5.40493 4.85029L6.1051 5.20704L5.32899 5.32997L5.20606 6.1061L4.84932 5.40594L4.07324 5.5289L4.62886 4.97328L4.27208 4.27309Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.93457 7.50127L3.6819 7.25843V6.47266L4.14374 7.1084L4.8911 6.86556L4.42918 7.50127L4.8911 8.13698L4.14374 7.89417L3.6819 8.52988V7.74411L2.93457 7.50127Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.27208 10.7295L4.62883 10.0293L4.07324 9.47366L4.84935 9.59665L5.20604 8.89648L5.32899 9.67259L6.10507 9.79552L5.40499 10.1523L5.52789 10.9283L4.97228 10.3727L4.27208 10.7295Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.49932 12.0658L7.25645 11.3185H6.4707L7.10645 10.8567L6.86357 10.1094L7.49932 10.5712L8.13503 10.1094L7.89219 10.8567L8.5279 11.3185H7.74213L7.49932 12.0658Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7275 10.7295L10.0273 10.3728L9.47168 10.9284L9.59464 10.1522L8.89453 9.79552L9.67061 9.67259L9.79354 8.89648L10.1503 9.59665L10.9263 9.47366L10.3707 10.0293L10.7275 10.7295Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0649 7.50127L11.3175 7.74411V8.52988L10.8557 7.89414L10.1084 8.13698L10.5703 7.50127L10.1084 6.86556L10.8557 7.1084L11.3175 6.47266V7.25846L12.0649 7.50127Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7275 4.27306L10.3707 4.97325L10.9264 5.52887L10.1502 5.40588L9.79354 6.10605L9.67061 5.32994L8.89453 5.20698L9.59464 4.85026L9.47168 4.07422L10.0274 4.6298L10.7275 4.27306Z",
  fill: "#FFDA44"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5207_30118"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEuropeanUnion);
export { ForwardRef as ReactComponent };